import styled from "@emotion/styled";

const Container = styled.div`
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const Label = styled.div`
  margin: 10px 0px 10px 0px;
  text-align: left;
  flex: 1;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
`;

const Children = styled.div`
  flex: 2;
`;

const SC = {
  Container,
  Label,
  Children,
};

export default SC;
